import { useMemo } from "react";
import { format } from "date-fns";
import { apiGet } from "../utils/apiClient";

/**
 * Retrieves FixedRouteBusBlocksByBlockNumber data.
 * @returns - A promise that resolves to the FixedRouteBusBlocksByBlockNumber data.
 */
export const useFetchFixedRouteBusBlocksByNumber = () => {
  const memoizedFetchFixedRouteBusBlocksByNumber = useMemo(
    () => async (boxJumpToVal, assignmentDate, rowFilter, pulloutDivision) => {
      const apiDate = format(assignmentDate, "dd-MMM-yyyy");
      return apiGet(
        `/FixedRouteBusBlocksByBlockNumber/${apiDate}/${rowFilter}/${pulloutDivision}/${boxJumpToVal}`,
        "fetching Fixed Route Bus Blocks By Number"
      );
    },
    []
  );

  return memoizedFetchFixedRouteBusBlocksByNumber;
};
